export interface Point { x: number; y: number }

export function toCanvasCoordinates(stagePos: Point, scale: number, pointer: Point): Point {
  return { x: (pointer.x - stagePos.x) / scale, y: (pointer.y - stagePos.y) / scale };
}

export function computeWheelZoom(oldScale: number, pointer: Point, stagePos: Point, deltaY: number, scaleBy = 1.05) {
  const mousePointTo = { x: (pointer.x - stagePos.x) / oldScale, y: (pointer.y - stagePos.y) / oldScale };
  const direction = deltaY > 0 ? -1 : 1;
  const targetScale = direction > 0 ? oldScale * scaleBy : oldScale / scaleBy;
  const boundedScale = Math.min(2, Math.max(0.01, targetScale));
  const newPos = { x: pointer.x - mousePointTo.x * boundedScale, y: pointer.y - mousePointTo.y * boundedScale };
  return { scale: boundedScale, position: newPos };
}

export function computePanStart(stagePos: Point, pointer: Point): Point {
  return { x: pointer.x - stagePos.x, y: pointer.y - stagePos.y };
}

export function computePanMove(panStart: Point, pointer: Point): Point {
  return { x: pointer.x - panStart.x, y: pointer.y - panStart.y };
}


